module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('span', [_vm._v("Ratificações " + _vm._s(_vm.ehDoUsuario ? 'pendentes de aprovação' : '') + " ")]), _vm._v(" "), (!_vm.ehDoUsuario) ? _c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'edita-ratificacao'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova Ratificação\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.ehDoUsuario) ? _c('g-button-ujarak', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'lista-ratificacao-pendentes'
        })
      }
    }
  }, [_vm._v("\n          Pendentes\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Remessa',
        href: '#'
      }, {
        text: 'Lista de Ratificações',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "listaRatificacoes"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table.filter),
      expression: "table.filter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.table, "filter", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.table.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.table.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.listaRatificacoes,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.filtrar,
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "id_processo",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }, {
      key: "nome",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
      }
    }, {
      key: "data_solicitacao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
      }
    }, {
      key: "situacao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
      }
    }, {
      key: "ultima_tarefa",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
      }
    }, {
      key: "resultado",
      fn: function(row) {
        return [(_vm.ehDoUsuario) ? _c('span', [(_vm._.includes(row.value, 'Sim')) ? _c('span', [_c('i', {
          staticClass: "fa fa-check text-green",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Aprovado")]) : (_vm._.includes(row.value, 'Nao')) ? _c('span', [_c('i', {
          staticClass: "fa fa-times text-red",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("Não aprovado")]) : _c('span', {
          staticClass: "text-blue"
        }, [_vm._v("Pendente")])]) : _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('span', [(row.item.ultima_tarefa === 'CONCLUSAO') ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("Aguarda conclusão"), _c('br'), _vm._v(_vm._s(row.value) + " assinatura(s)")]) : (row.item.ultima_tarefa === 'ASSINATURA_RATIFICACAO') ? _c('span', {
          staticStyle: {
            "color": "royalblue"
          }
        }, [_vm._v("Aguarda assinatura"), _c('br'), _vm._v(_vm._s(row.value) + " assinado(s)")]) : _c('span', [_vm._v(_vm._s(_vm.enumeradores[row.item.ultima_tarefa]))])]) : _c('span', [_vm._v(" ")])])]
      }
    }, {
      key: "acoes",
      fn: function(row) {
        return [(_vm.ehDoUsuario) ? _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-ratificacao',
                params: {
                  id: row.item.id_processo,
                  assinar: true
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Abrir\n                          ")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(row.item.resultado)) ? _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-ratificacao',
                params: {
                  id: row.item.id_processo,
                  visualizacao: true,
                  assinar: true
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Visualizar\n                          ")]) : _vm._e()], 1) : _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-ratificacao',
                params: {
                  id: row.item.id_processo
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar\n                          ")]) : _vm._e(), _vm._v(" "), (row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "error",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.cancelar(row.item.id_processo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-ban",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Cancelar\n                          ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-ratificacao',
                params: {
                  id: row.item.id_processo,
                  visualizacao: true
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Visualizar\n                          ")])], 1)]
      }
    }])
  })], 1)], 1)])])]), _vm._v(" "), (!_vm.ehDoUsuario) ? _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table.filter),
      expression: "table.filter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.table, "filter", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.table.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.table.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.listaRatificacoesConcluidas,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.filtrar,
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "id_processo",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }, {
      key: "data_solicitacao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
      }
    }, {
      key: "ultima_tarefa",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
      }
    }, {
      key: "situacao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
      }
    }, {
      key: "nome",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm.enumeradores[row.value]))]
      }
    }, {
      key: "resultado",
      fn: function(row) {
        return [(_vm.ehDoUsuario) ? _c('span', [(_vm._.includes(row.value, 'Sim')) ? _c('span', [_c('i', {
          staticClass: "fa fa-check text-green",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Aprovado")]) : (_vm._.includes(row.value, 'Nao')) ? _c('span', [_c('i', {
          staticClass: "fa fa-times text-red",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("Não aprovado")]) : _c('span', {
          staticClass: "text-blue"
        }, [_vm._v("Pendente")])]) : _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('span', [(row.item.ultima_tarefa === 'CONCLUSAO') ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("Aguarda conclusão"), _c('br'), _vm._v(_vm._s(row.value) + " assinatura(s)")]) : (row.item.ultima_tarefa === 'ASSINATURA_RATIFICACAO') ? _c('span', {
          staticStyle: {
            "color": "royalblue"
          }
        }, [_vm._v("Aguarda assinatura"), _c('br'), _vm._v(_vm._s(row.value) + " assinado(s)")]) : _c('span', [_vm._v(_vm._s(_vm.enumeradores[row.item.ultima_tarefa]))])]) : _c('span', [_vm._v(" ")])])]
      }
    }, {
      key: "acoes",
      fn: function(row) {
        return [(_vm.ehDoUsuario) ? _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-ratificacao',
                params: {
                  id: row.item.id_processo,
                  assinar: true
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Abrir\n                          ")]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(row.item.resultado)) ? _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-ratificacao',
                params: {
                  id: row.item.id_processo,
                  visualizacao: true,
                  assinar: true
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Visualizar\n                          ")]) : _vm._e()], 1) : _c('span', [(row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-ratificacao',
                params: {
                  id: row.item.id_processo
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar\n                          ")]) : _vm._e(), _vm._v(" "), (row.item.situacao === 'EM_EXECUCAO') ? _c('g-button-ujarak', {
          attrs: {
            "color": "error",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.cancelar(row.item.id_processo)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-ban",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Cancelar\n                          ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "success",
            "size": "button--size-ss"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'edita-ratificacao',
                params: {
                  id: row.item.id_processo,
                  visualizacao: true
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Visualizar\n                          ")])], 1)]
      }
    }], null, false, 335110256)
  })], 1)], 1)])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Em execução")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluídas e Canceladas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0031c03a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/ratificacoes/ListaRatificacao.vue
// module id = 1838
// module chunks = 1